exports.host =  JSON.parse(process.env.VUE_APP_USE_HOST.toLowerCase()) ? location.host :location.hostname;
exports.siteUrl = process.env.VUE_APP_SITEURL; 
exports.baseUrl = process.env.VUE_APP_API_BASE_ELITE;
exports.Domain = process.env.VUE_APP_SITE_DOMAIN;
exports.benefitBaseUrl = process.env.VUE_APP_API_BASE_BENEFIT;

 
